var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisma = function SvgVisma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E70641",
    d: "M16.343 7c8.715.759 18.178 5.187 23.656 11.512 6.973 8.096 4.607 16.192-5.353 18.09s-23.657-3.163-30.63-11.26c-5.354-6.198-5.23-12.396-.373-15.812l27.64 20.746L16.344 7Z"
  })));
};
export default SvgVisma;